/*!
 * ulloa-fitment-apply.js — Filtra TODO el sitio al vehículo del garage (Fase 1, client-side).
 * Recorre las cards de producto (colecciones, búsqueda, secciones), marca con badge real
 * "Calza en tu {modelo}" lo compatible, ATENÚA + REORDENA lo no-compatible y ofrece un
 * toggle "Solo lo de mi auto". Reacciona a UlloaVehicle.onChange SIN recargar la página.
 *
 * Depende de window.UlloaVehicle (ulloa-vehicle-state.js cargado antes).
 * Límite honesto: solo afecta lo ya renderizado en la página (la paginación de Shopify
 * no conoce el calce). El conteo dice "X de Y en esta vista". Fase 2 = tags + Search&Discovery.
 */
(function (w, d) {
  'use strict';
  if (!w.UlloaVehicle) return;
  if (w.__ulloaApply) return; w.__ulloaApply = true; // idempotente: una sola instancia aunque se cargue dos veces
  var UV = w.UlloaVehicle;
  var CFG = w.UlloaFitment || {};
  // Solo filtramos donde tiene sentido: colecciones y búsqueda. NO en home/ficha (evita descuadrar
  // bloques destacados o los productos relacionados). El selector y el verificador PDP cubren el resto.
  var TPL = (CFG.template || '').toLowerCase();
  var FILTER_TEMPLATES = CFG.filterTemplates || ['collection', 'search'];
  var ITEM_SEL = CFG.itemSelector ||
    '#product-grid > li, ul.product-grid > li, .product-grid > li, li.grid__item, .collection .grid__item, .search__results-list > li';

  function gridItems() {
    var nodes = d.querySelectorAll(ITEM_SEL);
    var seen = [], out = [];
    nodes.forEach(function (n) { if (seen.indexOf(n) === -1) { seen.push(n); out.push(n); } });
    return out;
  }
  function handleOf(item) {
    if (item.dataset && item.dataset.ulloaHandle) return item.dataset.ulloaHandle.toLowerCase();
    var a = item.querySelector('a[href*="/products/"]');
    return a ? UV.handleFromUrl(a.getAttribute('href')) : '';
  }
  function mediaOf(item) {
    return item.querySelector('.card__media, .card__inner, .card, .product-card__image, .media') || item;
  }

  function clearUI() {
    d.querySelectorAll('.ulloa-badge,.ulloa-fbar').forEach(function (e) { e.remove(); });
    gridItems().forEach(function (it) { it.classList.remove('ulloa-fits', 'ulloa-nofit', 'ulloa-dim', 'ulloa-hide'); });
  }

  function buildBar(v, fitN, totalN, only) {
    var bar = d.createElement('div');
    bar.className = 'ulloa-fbar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Filtro por tu vehículo');
    var sub = fitN ? (fitN + ' repuesto' + (fitN === 1 ? '' : 's') + ' de tu ' + esc(v.label) + ' en esta página')
                   : ('Ninguno en esta página — activa "Solo lo de mi auto" para ver toda tu lista');
    bar.innerHTML =
      '<span class="ulloa-fbar__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14M5 17l1.5-5.5A2 2 0 0 1 8.4 10h7.2a2 2 0 0 1 1.9 1.5L19 17M5 17v2M19 17v2"></path><circle cx="7.5" cy="17" r="1.5"></circle><circle cx="16.5" cy="17" r="1.5"></circle></svg></span>' +
      '<span class="ulloa-fbar__tx"><b>Filtrando para tu ' + esc(v.label) + '</b>' +
      '<small>' + sub + '</small></span>' +
      '<a class="ulloa-fbar__all" href="' + (CFG.homeUrl || '/') + '?uf=piezas">Ver todo lo de mi auto</a>' +
      '<label class="ulloa-tg" data-on="' + (only ? 'true' : 'false') + '"><span class="ulloa-sw" aria-hidden="true"></span>Solo lo de mi auto</label>' +
      '<button class="ulloa-fbar__chg" type="button" aria-label="Cambiar o quitar mi vehículo">Cambiar</button>';
    bar.querySelector('.ulloa-tg').addEventListener('click', function () {
      var on = this.dataset.on !== 'true'; UV.onlyFits(on);
    });
    bar.querySelector('.ulloa-fbar__chg').addEventListener('click', function () {
      if (w.UlloaGarage && w.UlloaGarage.open) w.UlloaGarage.open();
      else d.dispatchEvent(new CustomEvent('ulloa:open-selector'));
    });
    return bar;
  }
  function esc(s) { return (s || '').toString().replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Seguridad: solo permite URLs http(s)/protocol-relative/raíz-relativa (mata javascript:/data:/etc.) y escapa para atributo. Inválida -> ''.
  function safeUrl(u) { u = (u || '').toString().trim(); return (/^https?:\/\//i.test(u) || /^\/\//.test(u) || u.charAt(0) === '/') ? esc(u) : ''; }

  // Lead WhatsApp: las cards NATIVAS "a pedido" (card-product.liquid) traen su CTA "Cotizar" con
  // data-uf-waq + mensaje base; aquí le seteamos el href vía UV.waLink para adjuntar patente + N° chasis
  // del vehículo activo (igual que el resto de botones WhatsApp). Idempotente; corre en cada apply().
  function wireWaq() {
    try {
      if (!UV || !UV.waLink) return;
      d.querySelectorAll('a[data-uf-waq][data-uf-waq-msg]').forEach(function (a) {
        a.href = UV.waLink(a.getAttribute('data-uf-waq-msg'));
      });
    } catch (e) {}
  }

  function placeBar(bar) {
    // IDEMPOTENTE: quita cualquier barra previa de la misma clase antes de insertar (evita el banner
    // "Estás viendo todo el catálogo" DUPLICADO cuando apply()/placeBar se invoca más de una vez).
    var cls = (bar.className || '').split(' ')[0];
    if (cls) d.querySelectorAll('.' + cls).forEach(function (e) { if (e !== bar) e.remove(); });
    var anchor = d.querySelector('[data-ulloa-fbar]');
    if (anchor) { anchor.innerHTML = ''; anchor.appendChild(bar); return; }
    var grid = d.querySelector('#product-grid, ul.product-grid, .product-grid, .search__results-list');
    if (grid && grid.parentNode) grid.parentNode.insertBefore(bar, grid);
  }

  /* ===== BÚSQUEDA estilo Boston: con auto activo, mostrar SOLO sus piezas que coinciden (completas) ===== */
  var HIGH = (CFG.highTicketClp || 80000);
  function clpFmt(n) { var x = parseFloat(n) || 0; return x > 0 ? '$' + x.toLocaleString('es-CL') : 'Precio a consultar'; }
  function deaccent(s) { s = (s || '').toString().toLowerCase(); return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s; }
  function matchesQuery(it, toks) {
    if (!toks.length) return true;
    var hay = deaccent((it.nombre || '') + ' ' + (it.oem || '') + ' ' + (it.grupo || ''));
    // OEM sin separadores: el cliente escribe 2244323000, 22443-23000 o 2244323000A y todos
    // deben calzar con el mismo código (regla de normalización guion/sufijo del proyecto).
    var hayOem = deaccent(it.oem || '').replace(/[^a-z0-9]/g, '');
    // Tolerante a plural español: "frenos"→"freno", "filtros"→"filtro", "amortiguadores"→"amortiguador".
    // Antes, con auto puesto, el tile "Frenos" (plural) NO calzaba con "DISCO FRENO" (singular) → 0
    // resultados ("no filtra bien"). Esto SÓLO ajusta el filtro de TEXTO; el match de compatibilidad
    // (handles/OEM en ulloa-vehicle-state.js) queda intacto.
    return toks.every(function (t) {
      if (hay.indexOf(t) !== -1) return true;
      var tn = t.replace(/[^a-z0-9]/g, '');
      if (tn.length >= 6 && (tn.match(/[0-9]/g) || []).length >= 4 && hayOem && hayOem.indexOf(tn) !== -1) return true; // código OEM: guiones fuera
      if (t.length > 4 && t.slice(-2) === 'es' && hay.indexOf(t.slice(0, -2)) !== -1) return true; // -es
      if (t.length > 3 && t.charAt(t.length - 1) === 's' && hay.indexOf(t.slice(0, -1)) !== -1) return true; // -s
      return false;
    });
  }
  /* ===== Derivación de TIPO y DISPONIBILIDAD a partir de los datos reales del item =====
     - A PEDIDO: sin stock fiable (it.stock<=0) o sin precio (precio_clp<=0) → CTA verde "Cotizar".
     - TIPO: del nombre del item ("ORIGINAL" → original, "ALTERNATIVO" → alt). Si no hay
       palabra, NO inventamos badge de tipo (queda sin badge: solo "Compatible").
     Estas funciones NO tocan la lógica de compatibilidad; solo clasifican lo ya cargado. */
  function isOnDemand(it) {
    // El server ya minimiza el stock a un booleano `disponible` (no cantidad exacta). Si viene, manda;
    // si no (dato viejo en caché), caemos al precio como antes.
    var price = parseFloat(it.precio_clp || 0) || 0;
    if (it.disponible === true) return false;   // el server confirma stock
    if (it.disponible === false) return true;   // el server confirma sin stock
    return price <= 0;                           // sin flag: a pedido solo si no hay precio
  }
  function typeOf(it) {
    var n = deaccent(it.nombre || '');
    if (/\boriginal\b/.test(n)) return 'original';
    if (/\balternativ/.test(n)) return 'alt';
    return ''; // sin dato fiable → sin badge de tipo (no inventamos)
  }
  var TYPE_LABEL = { original: 'Original', alt: 'Alternativo', demand: 'A pedido' };
  function searchCard(it, model) {
    var demand = isOnDemand(it);
    var t = demand ? 'demand' : typeOf(it);
    var badge = t ? '<span class="ufc__type ufc__type--' + t + '">' + TYPE_LABEL[t] + '</span>' : '';
    var nv = it.n_variantes > 1 ? '<span class="uf__nv">+' + (it.n_variantes - 1) + '</span>' : '';
    var su = safeUrl(it.imagen); var thumb = su ? '<img src="' + su + '" alt="' + esc(it.nombre || '') + '" width="300" height="300" loading="lazy" onerror="this.style.display=\'none\'">' : '<span class="ph" aria-hidden="true"></span>';
    // FOOTER: a pedido → "Precio a consultar" + CTA verde "Cotizar" (a la ficha, igual que hoy).
    //         en stock → precio + botón crimson "Ver producto" (a la ficha).
    var foot = demand
      ? '<div class="ufc__demand-foot"><span class="ufc__ask">Precio a consultar</span><a class="ufc__quote" data-product-title="' + esc(it.nombre || '') + '" data-product-sku="' + esc(it.oem || '') + '" data-product-url="' + (safeUrl(it.url) || '') + '" data-product-price="' + ((parseFloat(it.precio_clp || 0) || 0) * 100) + '" target="_blank" rel="noopener" href="' + UV.waLink('Hola! Quiero cotizar: ' + (it.nombre || '') + (it.oem ? (' (OEM ' + it.oem + ')') : '')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>Cotizar</a></div>'
      : '<p class="uf__price">' + clpFmt(it.precio_clp) + '</p><a class="uf__buy" href="' + (safeUrl(it.url) || '#') + '">Ver producto</a>';
    return '<article class="uf__prod" data-type="' + (t || '') + '" data-demand="' + (demand ? '1' : '0') + '">' +
      '<a href="' + (safeUrl(it.url) || '#') + '" class="uf__thumb">' + badge + nv + thumb + '</a>' +
      '<div class="uf__pb"><p class="uf__oem">' + esc(it.oem || '') + '</p><h3 class="uf__pn">' + esc(it.nombre || '') + '</h3>' +
      '<span class="uf__compat"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4 4 10-10"></path></svg>Compatible</span>' + foot + '</div></article>';
  }
  var HIDE_SELS = ['.product-grid-container', '#product-grid', 'ul.product-grid', '.product-grid', '.search__results-list',
     '.facets-container', 'facet-filters-form', '.product-count', '.collection-toolbar',
     '.pagination', 'nav.pagination', '[data-id="pagination"]'];
  function hideStoreResults() {
    // Ocultamos resultados nativos + barra de filtros/orden/conteo (no aplican a la vista filtrada).
    // Guardamos el display inline previo en data-ulloa-prevdisplay para restaurarlo EXACTO al quitar/
    // cambiar el auto. Idempotente: si ya lo marcamos, NO re-tocar (evita "blanco pegado"). Ya NO
    // saltamos por computed-display: eso podía dejar la grilla en display:none sin marca → irrecuperable.
    HIDE_SELS.forEach(function (sel) {
      d.querySelectorAll(sel).forEach(function (el) {
        if (el.getAttribute('data-ulloa-hidden')) return;          // ya ocultado por nosotros
        el.setAttribute('data-ulloa-prevdisplay', el.style.display || '');
        el.setAttribute('data-ulloa-hidden', '1');
        el.style.display = 'none';
      });
    });
  }
  function restoreStoreResults() {
    // Devuelve la visibilidad a TODO lo que nosotros ocultamos (al quitar/cambiar auto o ver "todo"),
    // restaurando el display inline PREVIO (no asumimos "" — respeta lo que el tema tenía).
    d.querySelectorAll('[data-ulloa-hidden]').forEach(function (el) {
      el.style.display = el.getAttribute('data-ulloa-prevdisplay') || '';
      el.removeAttribute('data-ulloa-hidden');
      el.removeAttribute('data-ulloa-prevdisplay');
    });
  }
  function directChildOf(parent, el) { while (el && el.parentNode && el.parentNode !== parent) el = el.parentNode; return (el && el.parentNode === parent) ? el : null; }
  function insertWrap(wrap) {
    var main = d.querySelector('#MainContent') || d.querySelector('main');
    var pgc = d.querySelector('.product-grid-container') || d.querySelector('#product-grid');
    if (pgc && pgc.parentNode) pgc.parentNode.insertBefore(wrap, pgc);
    else if (main) main.appendChild(wrap);
    // Autocorrección de centrado: si quedó pegado a un borde, re-anclar al contenedor full-width (margin auto centra).
    try {
      var r = wrap.getBoundingClientRect();
      if (main && window.innerWidth > 900 && r.left < window.innerWidth * 0.08 && r.width < window.innerWidth * 0.85) {
        var form = main.querySelector('form[action*="/search"]');
        var after = form ? directChildOf(main, form) : null;
        if (after) main.insertBefore(wrap, after.nextSibling);
        else main.insertBefore(wrap, directChildOf(main, pgc) || main.firstChild);
      }
    } catch (e) {}
  }
  /* ===== Réplica "Colección Mix": SIDEBAR (268px) + GRID (3-col) =====
     paintSearch arma TODA la vista. La lista de compatibles (`matches`) se calcula
     UNA vez (matching/dedup intactos); el SIDEBAR sólo FILTRA en cliente esa lista y
     re-pinta el grid. NO se re-consulta el set ni se toca UV.getFull/refetch. */
  var CHK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4 4 10-10"></path></svg>';
  function gridHtml(list, model) {
    if (!list.length) return '<div class="ulloa-vsearch__nores">Ningún repuesto con esos filtros. <button type="button" class="ulloa-vsearch__reset">Quitar filtros</button></div>';
    return list.map(function (it) { return searchCard(it, model); }).join('');
  }
  // Conteos REALES (length de arrays) — nunca inventados.
  function countBy(arr, pred) { var n = 0; arr.forEach(function (x) { if (pred(x)) n++; }); return n; }
  function paintSearch(v, dd) {
    // GUARDA anti-carrera: si el auto se quitó/cambió mientras un refetch estaba en vuelo, NO pintamos
    // (si no, re-ocultaríamos la grilla nativa y dejaríamos un panel huérfano = "se rompe todo al sacar el auto").
    if (!UV.get()) { restoreStoreResults(); d.querySelectorAll('.ulloa-vsearch').forEach(function (e) { e.remove(); }); return; }
    d.querySelectorAll('.ulloa-vsearch').forEach(function (e) { e.remove(); }); // arranca limpio (idempotente)
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    var toks = deaccent(q).split(/\s+/).filter(Boolean);
    var model = UV.cleanModel(v.model);
    var items = []; (dd.grupos || []).forEach(function (g) { (g.items || []).forEach(function (it) { items.push(it.grupo ? it : Object.assign({ grupo: g.grupo }, it)); }); });
    // `matches` = lista de compatibles ya resuelta (esta es la ventaja vs paginación Shopify).
    var matches = items.filter(function (it) { return matchesQuery(it, toks); });
    hideStoreResults();
    var allUrl = location.pathname + location.search + (location.search ? '&' : '?') + 'uf=all';

    // ---- Datos REALES para el sidebar (conteos = piezas que YA pasan el filtro, sin inventar) ----
    // Categoría: derivada de `matches` (lo que de verdad se ve), NO del set completo del auto. Así
    // "Todas (N)" y cada categoría reconcilian, y al clickear una categoría el conteo SÍ calza
    // (antes "Todas" usaba matches pero las categorías el total del grupo → "Todas 3" junto a "Chasis 14").
    var grupoCount = {};
    matches.forEach(function (it) { var g = (it.grupo || ''); if (g) grupoCount[g] = (grupoCount[g] || 0) + 1; });
    var grupos = Object.keys(grupoCount).map(function (g) { return { grupo: g, n: grupoCount[g] }; })
                       .sort(function (a, b) { return b.n - a.n; });
    // Disponibilidad: sólo mostramos los flags que existen de verdad en los datos.
    var nStock = countBy(matches, function (it) { return !isOnDemand(it); });
    var nDemand = countBy(matches, function (it) { return isOnDemand(it); });
    // Tipo: derivado del nombre; sólo ofrecemos el checkbox si hay items de ese tipo.
    var nOrig = countBy(matches, function (it) { return typeOf(it) === 'original' && !isOnDemand(it); });
    var nAlt = countBy(matches, function (it) { return typeOf(it) === 'alt' && !isOnDemand(it); });

    var wrap = d.createElement('div'); wrap.className = 'ulloa-vsearch uf ulloa-scope';

    if (!matches.length) {
      try { var _zk = (v.label || '') + '|' + q; if (w.__ufZeroK !== _zk) { w.__ufZeroK = _zk; (w.ufTrack || function () {})('fitment_zero_results', { q: q || '', vehicle_label: v.label || '' }); } } catch (e) {}
      var head0 = '<div class="ulloa-vsearch__head"><span class="ulloa-fbar__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14M5 17l1.5-5.5A2 2 0 0 1 8.4 10h7.2a2 2 0 0 1 1.9 1.5L19 17M5 17v2M19 17v2"></path><circle cx="7.5" cy="17" r="1.5"></circle><circle cx="16.5" cy="17" r="1.5"></circle></svg></span><div><b>Sin repuestos de tu ' + esc(v.label) + (q ? (' para “' + esc(q) + '”') : '') + '</b><small>Resultados filtrados según tu vehículo · <a href="' + allUrl + '">Ver catálogo completo</a>' + (v.source === 'modelo' ? ' · <button type="button" data-uf-certify style="cursor:pointer;background:none;border:0;padding:0;font:inherit;color:var(--crimson,#D60041);font-weight:700;text-decoration:underline;text-underline-offset:2px">Certificar con mi patente</button>' : '') + '</small></div></div>';
      wrap.innerHTML = head0 + '<div class="ulloa-vsearch__empty">No encontramos piezas de tu ' + esc(v.label) + (q ? (' para “' + esc(q) + '”') : '') + '.<div class="ulloa-vsearch__empty-cta"><a class="uf__buy" style="display:inline-flex;width:auto;padding:0 16px" href="' + allUrl + '">Ver todos los resultados</a><a class="uf__buy wa" style="display:inline-flex;width:auto;padding:0 16px" target="_blank" rel="noopener" href="' + UV.waLink('Hola! Busco "' + q + '" para mi ' + v.label) + '">Consultar por WhatsApp</a></div></div>';
      insertWrap(wrap);
      return;
    }

    // ---- HEADER: breadcrumb + H2 + línea "N repuestos compatibles con tu {auto}" ----
    var activeGrupo = (grupos.length === 1) ? grupos[0].grupo : '';
    var crumbLast = activeGrupo ? esc(activeGrupo) : 'Resultados';
    var title = activeGrupo ? esc(activeGrupo) : (q ? ('Resultados para “' + esc(q) + '”') : 'Repuestos para tu ' + esc(v.label));
    var head =
      '<div class="ulloa-vsearch__top">' +
        '<nav class="ulloa-vsearch__crumbs" aria-label="Migas">' +
          '<a class="ulloa-vsearch__crumb" href="' + (CFG.homeUrl || '/') + '">Inicio</a>' +
          '<span class="ulloa-vsearch__crumb-sep" aria-hidden="true">/</span>' +
          '<span class="ulloa-vsearch__crumb ulloa-vsearch__crumb--current">' + crumbLast + '</span>' +
        '</nav>' +
        '<div class="ulloa-vsearch__headrow">' +
          '<h2 class="ulloa-vsearch__title">' + title + '</h2>' +
        '</div>' +
        '<p class="ulloa-vsearch__count" role="status" aria-live="polite"><span class="ulloa-vsearch__count-n" data-uf-count>' + matches.length + '</span> repuesto' + (matches.length === 1 ? ' <b>compatible</b> con tu ' : 's <b>compatibles</b> con tu ') + esc(v.label) + ' · <a class="ulloa-vsearch__all" href="' + allUrl + '">Ver catálogo completo</a></p>' +
        (v.source === 'modelo' ? '<p class="ulloa-vsearch__certify" style="margin:6px 0 0;font-size:13px;line-height:1.45;color:var(--text-soft,#726d63)">Resultados según <b>modelo y año</b>. Para certificar la compatibilidad con tu versión exacta, <button type="button" class="ulloa-vsearch__certify-cta" data-uf-certify style="cursor:pointer;background:none;border:0;padding:0;font:inherit;color:var(--crimson,#D60041);font-weight:700;text-decoration:underline;text-underline-offset:2px">agrega tu patente o N° de chasis</button></p>' : '') +
      '</div>';

    // ---- SIDEBAR ----
    // (a) Card "TU VEHÍCULO" + toggle visual "Solo compatibles"
    var aside = '<aside class="ulloa-vsearch__aside">' +
      '<div class="ulloa-vsearch__veh">' +
        '<span class="ulloa-vsearch__veh-eyebrow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M5 17l1.5-5.5A2 2 0 0 1 8.4 10h7.2a2 2 0 0 1 1.9 1.5L19 17M5 17v2M19 17v2"></path><circle cx="7.5" cy="17" r="1.5"></circle><circle cx="16.5" cy="17" r="1.5"></circle></svg>Tu vehículo</span>' +
        '<div class="ulloa-vsearch__veh-name">' + esc(v.label) + '</div>' +
        '<button type="button" class="ulloa-vsearch__veh-toggle" data-uf-only role="switch" aria-checked="true" aria-label="Solo compatibles: activado. Toca para ver el catálogo completo" style="cursor:pointer;background:none;border:0;padding:0;font:inherit;outline-offset:3px"><span class="ulloa-vsearch__switch" style="background:var(--crimson,#D60041)"><span class="ulloa-vsearch__switch-knob" style="transform:translateX(15px)"></span></span>Solo compatibles</button>' +
      '</div>';

    // (b) CATEGORÍA: grupos reales con conteo real
    if (grupos.length) {
      aside += '<div class="ulloa-vsearch__grp"><h3 class="ulloa-vsearch__grp-t">Categoría</h3><ul class="ulloa-vsearch__cats">';
      aside += '<li><button type="button" class="ulloa-vsearch__cat is-active" data-cat="" aria-pressed="true">Todas <span class="ulloa-vsearch__cat-n">' + matches.length + '</span></button></li>';
      grupos.forEach(function (g) {
        aside += '<li><button type="button" class="ulloa-vsearch__cat" data-cat="' + esc(g.grupo) + '" aria-pressed="false">' + esc(g.grupo) + ' <span class="ulloa-vsearch__cat-n">' + g.n + '</span></button></li>';
      });
      aside += '</ul></div>';
    }

    // (c) DISPONIBILIDAD: sólo los flags con datos reales
    var dispRows = '';
    if (nStock) dispRows += '<li><label class="ulloa-vsearch__check"><input type="checkbox" data-avail="stock"><span class="ulloa-vsearch__check-box">' + CHK_SVG + '</span><span class="ulloa-vsearch__check-tx">En stock</span><span class="ulloa-vsearch__count-n">' + nStock + '</span></label></li>';
    if (nDemand) dispRows += '<li><label class="ulloa-vsearch__check"><input type="checkbox" data-avail="demand"><span class="ulloa-vsearch__check-box">' + CHK_SVG + '</span><span class="ulloa-vsearch__check-tx">A pedido</span><span class="ulloa-vsearch__count-n">' + nDemand + '</span></label></li>';
    if (dispRows) aside += '<div class="ulloa-vsearch__grp"><h3 class="ulloa-vsearch__grp-t">Disponibilidad</h3><ul class="ulloa-vsearch__opts">' + dispRows + '</ul></div>';

    // (d) TIPO: derivado del nombre; sólo si hay items de ese tipo
    var typeRows = '';
    if (nOrig) typeRows += '<li><label class="ulloa-vsearch__check"><input type="checkbox" data-type="original"><span class="ulloa-vsearch__check-box">' + CHK_SVG + '</span><span class="ulloa-vsearch__check-tx">Original (OEM)</span><span class="ulloa-vsearch__count-n">' + nOrig + '</span></label></li>';
    if (nAlt) typeRows += '<li><label class="ulloa-vsearch__check"><input type="checkbox" data-type="alt"><span class="ulloa-vsearch__check-box">' + CHK_SVG + '</span><span class="ulloa-vsearch__check-tx">Alternativo</span><span class="ulloa-vsearch__count-n">' + nAlt + '</span></label></li>';
    if (typeRows) aside += '<div class="ulloa-vsearch__grp"><h3 class="ulloa-vsearch__grp-t">Tipo</h3><ul class="ulloa-vsearch__opts">' + typeRows + '</ul></div>';

    aside += '</aside>';

    // ---- LAYOUT 2 columnas ----
    var layout = head + '<div class="ulloa-vsearch__layout">' + aside +
      '<div class="ulloa-vsearch__main"><div class="uf__grid" data-uf-grid>' + gridHtml(matches, model) + '</div></div></div>';
    wrap.innerHTML = layout;
    insertWrap(wrap);

    // Toggle "Solo compatibles" (card TU VEHÍCULO): switch real ON→ver catálogo completo (uf=all).
    // ON = estado actual (sólo compatibles). Al activarlo navega al MISMO allUrl de "Ver catálogo completo".
    var onlyTg = wrap.querySelector('[data-uf-only]');
    if (onlyTg) onlyTg.addEventListener('click', function () {
      onlyTg.setAttribute('aria-checked', 'false');
      // Apagar el filtro "solo compatibles" para que la vista completa (uf=all) muestre TODO el
      // catálogo (sin esto la colección nativa queda filtrada a compatibles = 0 productos).
      try { UV.onlyFits(false); } catch (e) {}
      location.href = allUrl;
    });

    // ===== Filtrado CLIENT-SIDE: re-pinta SOLO el grid sobre la lista de compatibles =====
    var state = { cat: '', avail: {}, type: {} };
    var gridEl = wrap.querySelector('[data-uf-grid]');
    var countEl = wrap.querySelector('[data-uf-count]');
    function applyFilters() {
      var availOn = Object.keys(state.avail).filter(function (k) { return state.avail[k]; });
      var typeOn = Object.keys(state.type).filter(function (k) { return state.type[k]; });
      var filtered = matches.filter(function (it) {
        if (state.cat && (it.grupo || '') !== state.cat) return false;
        if (availOn.length) {
          var dem = isOnDemand(it);
          var ok = (dem && state.avail.demand) || (!dem && state.avail.stock);
          if (!ok) return false;
        }
        if (typeOn.length) {
          if (isOnDemand(it)) return false; // los "a pedido" no llevan tipo Original/Alternativo
          if (typeOn.indexOf(typeOf(it)) === -1) return false;
        }
        return true;
      });
      gridEl.innerHTML = gridHtml(filtered, model);
      if (countEl) countEl.textContent = filtered.length;
    }
    // Categoría (radio-like)
    wrap.querySelectorAll('.ulloa-vsearch__cat').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.ulloa-vsearch__cat').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true'); // a11y (#15): refleja el estado del grupo radio-like
        state.cat = btn.getAttribute('data-cat') || '';
        applyFilters();
      });
    });
    // Disponibilidad / Tipo (checkboxes)
    wrap.querySelectorAll('.ulloa-vsearch__check input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var a = inp.getAttribute('data-avail'), t = inp.getAttribute('data-type');
        if (a) state.avail[a] = inp.checked;
        if (t) state.type[t] = inp.checked;
        applyFilters();
      });
    });
    // "Quitar filtros" (estado sin resultados tras filtrar)
    gridEl.addEventListener('click', function (e) {
      if (!e.target.closest('.ulloa-vsearch__reset')) return;
      state = { cat: '', avail: {}, type: {} };
      wrap.querySelectorAll('.ulloa-vsearch__check input').forEach(function (i) { i.checked = false; });
      wrap.querySelectorAll('.ulloa-vsearch__cat').forEach(function (b) { var on = !b.getAttribute('data-cat'); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      applyFilters();
    });
  }
  function tokenOf(v) { return v ? (v.veh_key || v.label || '') : ''; }
  function renderVehicleSearch(v) {
    d.querySelectorAll('.ulloa-vsearch,.ulloa-fbar,.ulloa-badge').forEach(function (e) { e.remove(); });
    var full = UV.getFull();
    if (full) { paintSearch(v, full); return; }
    // Sin set en cache: lo pedimos. PERO el refetch es async; si el usuario quita/cambia el auto
    // mientras está en vuelo, NO debemos pintar con datos viejos. Capturamos el token y re-validamos.
    var token = tokenOf(UV.get() || v);
    UV.refetch().then(function (r) {
      var now = UV.get();
      if (!now || tokenOf(now) !== token) { restoreStoreResults(); return; } // auto quitado/cambiado: grilla nativa
      var dd = (r && r.ok && r.deduped) ? r.deduped : null;
      var hasItems = dd && (dd.grupos || []).some(function (g) { return (g.items || []).length; });
      // Set vacío o no disponible aún: mostrar la grilla nativa, NO un panel "Sin repuestos" sobre el vacío.
      // (Si el set SÍ trae piezas pero la búsqueda las filtra a 0, paintSearch muestra su estado vacío correcto.)
      if (!hasItems) { restoreStoreResults(); d.querySelectorAll('.ulloa-vsearch').forEach(function (e) { e.remove(); }); return; }
      paintSearch(now, dd);
    });
  }

  /* ===== BUSCADOR PREDICTIVO del header (Dawn <predictive-search>): con auto activo, SOLO sus piezas ===== */
  var CAR_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M5 17l1.5-5.5A2 2 0 0 1 8.4 10h7.2a2 2 0 0 1 1.9 1.5L19 17M5 17v2M19 17v2"></path><circle cx="7.5" cy="17" r="1.5"></circle><circle cx="16.5" cy="17" r="1.5"></circle></svg>';
  function predItems() {
    var full = UV.getFull(), items = [];
    if (full) (full.grupos || []).forEach(function (g) { (g.items || []).forEach(function (it) { items.push(it.grupo ? it : Object.assign({ grupo: g.grupo }, it)); }); });
    return { full: full, items: items };
  }
  function predRow(it) {
    var su = safeUrl(it.imagen); var thumb = su ? '<img src="' + su + '" alt="" width="56" height="56" loading="lazy" onerror="this.style.display=\'none\'">' : '<span class="ph" aria-hidden="true"></span>';
    return '<a class="ulloa-pred__row" href="' + (safeUrl(it.url) || '#') + '" role="option">' +
      '<span class="ulloa-pred__th">' + thumb + '</span>' +
      '<span class="ulloa-pred__info"><span class="ulloa-pred__nm">' + esc(it.nombre || '') + '</span>' +
      '<span class="ulloa-pred__oem">' + esc(it.oem || '') + '</span></span>' +
      '<span class="ulloa-pred__pr">' + (isOnDemand(it) ? 'Precio a consultar' : clpFmt(it.precio_clp)) + '</span></a>';
  }
  function buildPredPanel(v, q) {
    var pi = predItems();
    var searchUrl = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    var head = '<div class="ulloa-pred__head"><span class="ulloa-pred__ic">' + CAR_SVG + '</span><b>Repuestos de tu <em>' + esc(v.label) + '</em></b></div>';
    if (!pi.full) {
      // Set del auto no cargado: NO mostramos productos globales como si fueran del auto.
      return '<div class="ulloa-pred ulloa-scope">' + head +
        '<div class="ulloa-pred__msg">Presiona <b>Enter</b> para ver los repuestos de tu ' + esc(v.label) + '.</div></div>';
    }
    var toks = deaccent(q).split(/\s+/).filter(Boolean);
    var matches = pi.items.filter(function (it) { return matchesQuery(it, toks); });
    if (!matches.length) {
      return '<div class="ulloa-pred ulloa-scope">' + head +
        '<div class="ulloa-pred__msg">Sin repuestos de tu ' + esc(v.label) + ' para “' + esc(q) + '”.' +
        '<a class="ulloa-pred__all" href="' + searchUrl + '&uf=all">Buscar en toda la tienda</a>' +
        '<a class="ulloa-pred__all wa" target="_blank" rel="noopener" href="' + UV.waLink('Hola! Busco "' + q + '" para mi ' + v.label) + '">Consultar por WhatsApp</a></div></div>';
    }
    var rows = matches.slice(0, 6).map(predRow).join('');
    var foot = '<a class="ulloa-pred__all" href="' + searchUrl + '">Ver ' + matches.length + ' repuesto' + (matches.length === 1 ? '' : 's') + ' de tu ' + esc(v.label) + ' →</a>';
    return '<div class="ulloa-pred ulloa-scope">' + head + '<div class="ulloa-pred__list" role="listbox">' + rows + '</div>' + foot + '</div>';
  }
  var predWriting = false;
  function paintPred(container, input) {
    if (predWriting) return;
    var v = UV.get();
    var q = (input && input.value || '').trim();
    if (!v || q.length < 2) return; // sin auto o query corta: dejamos el predictivo nativo de Dawn
    if (container.getAttribute('data-ulloa-pred') === q && container.querySelector('.ulloa-pred')) return; // ya pintado Y nuestro panel sigue en el DOM (Dawn re-renderiza encima con fetch tardío/caché de sugerencias)
    predWriting = true;
    try { container.innerHTML = buildPredPanel(v, q); container.setAttribute('data-ulloa-pred', q); } catch (e) {}
    setTimeout(function () { predWriting = false; }, 0);
  }
  function initPredictive() {
    var hosts = d.querySelectorAll('predictive-search');
    if (!hosts.length) return;
    hosts.forEach(function (host) {
      var container = host.querySelector('[data-predictive-search]');
      var input = host.querySelector('input[name="q"], input[type="search"]');
      if (!container || !input) return;
      if (host.__ufPredInit) return; // evita MutationObservers duplicados si initPredictive corre otra vez (fuga)
      host.__ufPredInit = true;
      // Dawn re-renderiza el contenedor en cada pulsación (fetch a /search/suggest). Cuando lo hace,
      // si hay auto activo, sobre-escribimos con SOLO las piezas del auto que coinciden.
      var obs = new MutationObserver(function () { paintPred(container, input); });
      obs.observe(container, { childList: true, subtree: true });
      // si el usuario borra el query, soltamos la marca para que vuelva el predictivo nativo
      input.addEventListener('input', function () {
        if ((input.value || '').trim().length < 2) container.removeAttribute('data-ulloa-pred');
      });
    });
  }

  function apply() {
    if (FILTER_TEMPLATES.indexOf(TPL) === -1) return; // fuera de colección/búsqueda no tocamos el DOM
    var v = UV.get();
    wireWaq(); // lead WhatsApp: adjunta patente+chasis a los CTA "Cotizar" a-pedido de las cards nativas
    restoreStoreResults(); // primero devolvemos la grilla nativa; abajo se vuelve a ocultar SOLO si pintamos la vista del auto
    // "Ver catálogo completo" (uf=all): soltamos el filtro por completo — catálogo neutral, sin badges ni atenuado.
    if (/[?&]uf=all\b/i.test(location.search)) {
      clearUI();
      d.querySelectorAll('.ulloa-vsearch,.ulloa-ufall-bar').forEach(function (e) { e.remove(); });
      d.documentElement.classList.add('ulloa-uf-off');
      // uf=all = estado OFF de "solo compatibles": reconciliamos el flag persistido (loop-safe ===true)
      // para que la cáscara .ufco no muestre el chip "Solo compatibles" activo ni reaparezca al navegar.
      try { if (UV.onlyFits && UV.onlyFits() === true) UV.onlyFits(false); } catch (e) {}
      // Con vehículo activo: barra para VOLVER a "solo compatibles" (sin esto el usuario queda atrapado
      // en el catálogo completo: en uf=all no se inyecta la card TU VEHÍCULO ni su toggle).
      if (v) {
        var qsBack = location.search.replace(/^\?/, '').split('&').filter(function (p) { return p && !/^uf=all$/i.test(p); });
        var compatUrl = location.pathname + (qsBack.length ? '?' + qsBack.join('&') : '');
        var fb = d.createElement('div');
        fb.className = 'ulloa-ufall-bar ulloa-scope';
        fb.innerHTML =
          '<span class="ulloa-ufall-bar__tx"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M5 17l1.5-5.5A2 2 0 0 1 8.4 10h7.2a2 2 0 0 1 1.9 1.5L19 17M5 17v2M19 17v2"></path><circle cx="7.5" cy="17" r="1.5"></circle><circle cx="16.5" cy="17" r="1.5"></circle></svg>Estás viendo <b>todo el catálogo</b>.</span>' +
          '<a class="ulloa-ufall-bar__cta" href="' + compatUrl + '"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4 4 10-10"></path></svg>Ver solo compatibles con tu ' + esc(v.label) + '</a>';
        placeBar(fb);
        // M7: la card estática del sidebar dice "Aún no eliges tu vehículo" aunque HAY auto activo
        // (contradice el chip del header y esta misma barra). La reconciliamos sin tocar su lógica.
        var vtx = d.querySelector('.ufco__vehcta-tx'), vsb = d.querySelector('.ufco__vehcta-sub'), vbt = d.querySelector('.ufco__vehcta-btn');
        if (vtx) vtx.textContent = v.label;
        if (vsb) vsb.textContent = 'Estás viendo el catálogo completo.';
        if (vbt) { for (var vi = 0; vi < vbt.childNodes.length; vi++) { var vn = vbt.childNodes[vi]; if (vn.nodeType === 3 && vn.textContent.trim()) vn.textContent = ' Cambiar auto'; } }
      }
      return;
    }
    d.documentElement.classList.remove('ulloa-uf-off');
    // BÚSQUEDA con auto activo: SOLO las piezas del vehículo que coinciden (completas). uf=all = ver todo de la tienda.
    if (TPL === 'search' && v && !/[?&]uf=all\b/i.test(location.search)) { renderVehicleSearch(v); return; }
    // COLECCIÓN con auto activo: SIEMPRE la vista filtrada limpia del vehículo (sin modo atenuado ni
    // "hojas vacías"). El modo atenuado dejaba espacios en blanco; se elimina. "Ver catálogo completo" (uf=all) muestra todo.
    if (TPL === 'collection' && v && !/[?&]uf=all\b/i.test(location.search)) { renderVehicleSearch(v); return; }
    d.querySelectorAll('.ulloa-vsearch').forEach(function (e) { e.remove(); });
    var set = UV.getSet();
    var items = gridItems();
    d.querySelectorAll('.ulloa-badge,.ulloa-fbar').forEach(function (e) { e.remove(); });
    if (!v || !set || !items.length) {
      items.forEach(function (it) { it.classList.remove('ulloa-fits', 'ulloa-nofit', 'ulloa-dim', 'ulloa-hide'); });
      return;
    }
    var handles = {}; set.handles.forEach(function (h) { handles[h] = 1; });
    var only = UV.onlyFits();
    d.documentElement.classList.toggle('ulloa-uf-off', !only); // filtro "pasivo" (toggle off): badges en escala de grises
    var fitN = 0;

    // PERF (#39): separar LECTURAS de ESCRITURAS para evitar layout thrashing.
    // Antes getComputedStyle(media) corría DENTRO del loop justo antes de un media.style.position =
    // ... → forzaba un reflow síncrono por card. Aquí: 1ª pasada SOLO clasifica + LEE estilos
    // (sin escribir nada que invalide el layout); 2ª pasada SOLO escribe (clases, position, badge).
    // La lógica de compatibilidad (handleOf/handles) queda idéntica, solo se reordena el trabajo DOM.
    var fitJobs = [];
    items.forEach(function (it) {
      var h = handleOf(it);
      var fits = h && handles[h];
      if (fits) {
        fitN++;
        var media = mediaOf(it);
        // LECTURA agrupada: leer position computada ahora, antes de cualquier escritura del lote.
        fitJobs.push({ it: it, media: media, needRel: getComputedStyle(media).position === 'static' });
      } else {
        fitJobs.push({ it: it, media: null, needRel: false });
      }
    });
    // ESCRITURAS agrupadas: ya no hay getComputedStyle intercalado → el navegador no recalcula por card.
    fitJobs.forEach(function (job) {
      var it = job.it;
      if (job.media) {
        it.classList.toggle('ulloa-fits', true);
        it.classList.toggle('ulloa-nofit', false);
        it.classList.remove('ulloa-dim', 'ulloa-hide');
        if (job.needRel) job.media.style.position = 'relative';
        var badge = d.createElement('span');
        badge.className = 'ulloa-badge';
        badge.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4 4 10-10"></path></svg>' + (v.source === 'modelo' ? 'Compatible con ' + esc(UV.cleanModel(v.model)) + (v.year ? ' ' + esc(String(v.year)) : '') : 'Compatible con tu ' + esc(UV.cleanModel(v.model)));
        job.media.insertBefore(badge, job.media.firstChild);
      } else {
        it.classList.toggle('ulloa-fits', false);
        it.classList.toggle('ulloa-nofit', true);
        it.classList.remove('ulloa-dim', 'ulloa-hide');
        it.classList.add('ulloa-dim'); // nunca ocultar por página (evita hojas vacías); "solo lo de mi auto" usa la lista completa
      }
    });

    // Reordenar: compatibles primero, preservando orden relativo, dentro de cada contenedor.
    var groups = {};
    items.forEach(function (it) {
      var p = it.parentNode; if (!p) return;
      var id = p.__ulloaId || (p.__ulloaId = Math.random().toString(36).slice(2));
      (groups[id] = groups[id] || { p: p, list: [] }).list.push(it);
    });
    Object.keys(groups).forEach(function (id) {
      var g = groups[id], fits = [], rest = [];
      g.list.forEach(function (it) { (it.classList.contains('ulloa-fits') ? fits : rest).push(it); });
      fits.concat(rest).forEach(function (it) { g.p.appendChild(it); });
    });

    placeBar(buildBar(v, fitN, items.length, only));
  }

  UV.onChange(function () { apply(); });
  // CTA "certificar con patente" (modo manual): listener delegado — cubre la vista con
  // resultados, el estado vacío y cualquier repintado, sin duplicar listeners.
  d.addEventListener('click', function (e) {
    var b = (e.target && e.target.closest) ? e.target.closest('[data-uf-certify]') : null;
    if (!b) return;
    if (w.UlloaGarage && w.UlloaGarage.open) w.UlloaGarage.open();
    else { try { d.dispatchEvent(new CustomEvent('ulloa:open-selector')); } catch (err) {} }
    // El CTA promete "patente": aterrizar en esa pestaña del modal (si existe).
    try { var mm = d.getElementById('uf-modal'), ts = mm ? mm.querySelectorAll('.uf__tab') : []; for (var i = 0; i < ts.length; i++) { if (/patente/i.test(ts[i].textContent)) { ts[i].click(); break; } } } catch (err2) {}
  });

  function boot() { apply(); initPredictive(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})(window, document);
